export class MathUtil {
    constructor() {
    }
    static clamp(val, min, max) {
        return Math.min(Math.max(val, min), max);
    }
    static numberWithinPercentOfMod(value, mod, percent) {
        let t = (value % mod) / mod;
        return Math.abs(1 - t) < percent / 100 || t < percent / 100;
    }
}
//# sourceMappingURL=math-util.js.map